import * as superagent from "superagent";
import {config} from "../../config";
import {CurrencyDenominator} from "../CurrencyDenominator";
import {InfoModal} from "../InfoModal";
import {RouletteBets} from "./RouletteBetsProtocol";
import {AccountInfo} from "./serverResponseClasses/AccountInfo";
import {ServerResponse} from "./serverResponseClasses/ServerResponse";

export class ApiService {

    private readonly STEEM_ACCOUNT_NAME: string = "steemAccountName";
    private readonly STEEM_CONNECT_TOKEN: string = "steemConnectToken";
    private readonly KEYCHAIN_JWT: string = "keychainjwt";

    private steemAccountName: string;
    private steemConnectToken: string;
    private keychainJWT: string;

    constructor() {
    }

    public getGameResult(rouletteBetsOriginal: RouletteBets, betCurrency: string): Promise<ServerResponse> {
        const rouletteBets = JSON.parse(JSON.stringify(rouletteBetsOriginal));
        for (let i = 0; i < rouletteBets.colorBets.length; i++) {
            rouletteBets.colorBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.colorBets[i].betAmount);
        }
        for (let i = 0; i < rouletteBets.columnBets.length; i++) {
            rouletteBets.columnBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.columnBets[i].betAmount);
        }
        for (let i = 0; i < rouletteBets.cornerBets.length; i++) {
            rouletteBets.cornerBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.cornerBets[i].betAmount);
        }
        for (let i = 0; i < rouletteBets.dozenBets.length; i++) {
            rouletteBets.dozenBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.dozenBets[i].betAmount);
        }
        for (let i = 0; i < rouletteBets.evenOddBets.length; i++) {
            rouletteBets.evenOddBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.evenOddBets[i].betAmount);
        }
        for (let i = 0; i < rouletteBets.lineBets.length; i++) {
            rouletteBets.lineBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.lineBets[i].betAmount);
        }
        for (let i = 0; i < rouletteBets.lowHighNumbersBets.length; i++) {
            rouletteBets.lowHighNumbersBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.lowHighNumbersBets[i].betAmount);
        }
        for (let i = 0; i < rouletteBets.splitBets.length; i++) {
            rouletteBets.splitBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.splitBets[i].betAmount);
        }
        for (let i = 0; i < rouletteBets.straightBets.length; i++) {
            rouletteBets.straightBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.straightBets[i].betAmount);
        }
        for (let i = 0; i < rouletteBets.streetBets.length; i++) {
            rouletteBets.streetBets[i].betAmount =
                CurrencyDenominator.ToBase(rouletteBets.streetBets[i].betAmount);
        }

        return superagent
            .post(config.gameServerAddress + "/getGameResult")
            .set(this.STEEM_ACCOUNT_NAME, this.steemAccountName)
            .set(this.STEEM_CONNECT_TOKEN, this.steemConnectToken)
            .set(this.KEYCHAIN_JWT, this.keychainJWT)
            .send({steemAccountName: this.steemAccountName, currencyType: betCurrency, rouletteBets})
            .then((res): ServerResponse => {
                return res.body.data;
            })
            .then((res): ServerResponse => {
                res.accountInfo.steemAmount = CurrencyDenominator.ToMain(res.accountInfo.steemAmount);
                res.rouletteResult.prize = CurrencyDenominator.ToMain(res.rouletteResult.prize);
                res.rouletteResult.totalBetsAmount = CurrencyDenominator.ToMain(res.rouletteResult.totalBetsAmount);
                return res;
            })
            .catch((res) => {
                if (res.status === 402) {
                    InfoModal.open("You need more " + config.displayCurrency + " to keep playing.",
                        "Make a quick deposit and go back to the game!", () => {
                            if (top && top.window) {
                                top.window.location.replace(config.pageAddress);
                            } else {
                                window.location.replace(config.pageAddress);
                            }
                        });
                    InfoModal.setActionButtonText("GO TO MAKING DEPOSIT");
                }
            });
    }

    public initGame(steemAccountName: string, steemConnectToken: string, keychainJWT: string): Promise<AccountInfo> {
        return superagent
            .get(config.gameServerAddress + "/initGame")
            .set(this.STEEM_ACCOUNT_NAME, steemAccountName)
            .set(this.STEEM_CONNECT_TOKEN, steemConnectToken)
            .set(this.KEYCHAIN_JWT, keychainJWT)
            .send({})
            .then((res) => {
                this.steemAccountName = steemAccountName;
                this.steemConnectToken = steemConnectToken;
                this.keychainJWT = keychainJWT;
                return res.body.data;
            })
            .then((res: any) => {
                res.steemAmount = CurrencyDenominator.ToMain(res.steemAmount);
                return res;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/api/ApiService.ts